import { Role, User } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Heading, Table, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { ConfirmModal } from "../../modals/confirm-modal.modal";
import { iamService, usersService } from "../../services";
import { GrantRoleModal } from "../../modals/grant-role.modal";

type RolesQuickViewProps = {
    user: User;
    roles: Role[];
};

export const RolesQuickView = ({
    user,
    roles,
}: RolesQuickViewProps) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [dooomedRole, setDoomedRole] = useState<Role | undefined>(undefined);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const removeRole = async () => {
        if (dooomedRole) {
            await iamService.removeRoleFromUser(user.id, dooomedRole.id);
        }
        setConfirmModalOpen(false);
        onClose();
        setConfirmModalOpen(false);
    };

    const handleRemoveButtonClick = (role: Role) => {
        setConfirmModalOpen(true);
        setDoomedRole(role);
    };

    const grantRole = async (roleId: number) => {
        if (user) {
            const _user = await usersService.addRoleToUser(user.id, roleId);
            user = _user;
        }
        onClose();
    };

    return (
        <Box>
            <Flex>
                <Heading size={'lg'} mb={4}>Roles</Heading>
                <Button ml={'auto'} colorScheme="teal" onClick={onOpen}>Grant Role</Button>
            </Flex>
            <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>Id</Th>
                        <Th>Name</Th>
                        <Th>Description</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {user.roles?.map((role) => (
                        <Tr key={role.id}>
                            <Td>{role.id}</Td>
                            <Td>{role.name}</Td>
                            <Td>{role.description}</Td>
                            <Td>
                                <Button mr={2} size="sm" onClick={() => handleRemoveButtonClick(role)}>
                                    Delete
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            <GrantRoleModal
                isOpen={isOpen}
                onClose={onClose}
                roles={roles.filter((r) => !user.roles?.map((role) => role.id).includes(r.id))}
                onGrant={grantRole}
            />
            {dooomedRole && <ConfirmModal
                isOpen={confirmModalOpen}
                message={`Are you sure you want to remove this role (${dooomedRole.name})?`}
                onCancel={() => setConfirmModalOpen(false)}
                onClose={() => setConfirmModalOpen(false)}
                onConfirm={removeRole}
            />}
        </Box>
    )
}